<template>
  <router-view />
</template>

<script>
export default {
  name: 'HotelManagementBalanceHistoryIndex'
}
</script>
